import axios from "axios";
import Config from "../../config";
import moment from "moment";
import { encryptPayload } from "../../utils/encryption";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;
const APIKEYIDAMAN = "Bearer ";
const ROOT_URLIDAMAN = "https://login.idaman.pertamina.com/";
const ROOT_URLINFOINDAMAN = "https://rest.idaman.pertamina.com/";

const url = `${ROOT_URL}api/api-token-auth/`;
const encodeQuery = value => encodeURIComponent(value == null ? "" : value);

export function encrypted(text) {
  return encryptPayload(text);
}

export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token") }
  };
}

export function cekAuthIdaman(tokenIdaman) {
  return {
    headers: { Authorization: APIKEYIDAMAN + tokenIdaman }
  };
}

export function cekAuthIpman() {
  return cekAuth();
}

export function cekAuthCctv() {
  return cekAuth();
}

export function loginIpMan() {
  return cekAuth();
}

export function authIpman(token) {
  return cekAuth();
}

export function fetchLoginIpman() {
  const url = `${ROOT_URL}ipman/clientservices/login/`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchVoyageNoIpman(token, callsign, date) {
  const url = `${ROOT_URL}ipman/clientservices/voyage-order/?callsign=${encodeQuery(callsign)}&date=${encodeQuery(date)}`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function pushloggingx(requests, description) {
  const url = `${ROOT_URL}logactivity/logactivity/`;
  let ippublic = "-";

  const fdata = new FormData();
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("name", localStorage.getItem("name"));
  fdata.append("email", localStorage.getItem("email"));
  fdata.append("issuperuser", localStorage.getItem("is_superuser"));
  fdata.append("ipaddress", localStorage.getItem("ipaddress"));
  fdata.append("location", localStorage.getItem("location"));
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("os", "");
  fdata.append("activity", requests);
  fdata.append("description", description);


  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

function pushlogging(requests) {
  return true;
}

export function fetchDataipman(call_sign) {
  const url = `${ROOT_URL}ipman/mobile-voyage/?callsign=${encodeQuery(call_sign)}`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchtestPem(token) {
  const url = `${ROOT_URL}cctvactreport/remote/report/`;
  const request = axios.get(url, cekAuth());

  return request;
}

export function fetchShipnamecallsign() {
  const url = `${ROOT_URL}shipapirt/shipnamecallsign/`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchShiprtbt(ship_id, startDate, endDate, source_api) {
  const url = `${ROOT_URL}shipapits/shiptrackbt/?ship_id=${encrypted(
    ship_id
  )}&startDate=${encrypted(startDate)}&endDate=${encrypted(
    endDate
  )}&source_api=${encrypted(source_api)}`;
  const request = axios.get(url, cekAuth());
  pushlogging("get " + url);
  return request;
}

export function fetchEmailExist(email) {
  const url = `${ROOT_URL}api/profileemail/?email=${encrypted(email)}`;
  const request = axios.get(url);
  pushlogging("get " + url);
  return request;
}

export function fetchIpmants(start_date, end_date, call_sign) {
  //const url = `${ROOT_URL}ipmants/ipmantsbydate/?date_created=${date_created}&call_sign=${call_sign}`;
  const url = `${ROOT_URL}ipmants/ipmantsbydate/?start_date=${encrypted(
    start_date
  )}&end_date=${encrypted(end_date)}&call_sign=${encrypted(call_sign)}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchToken(username, password) {
  console.log(url);
  const request = axios.post(
    url,
    {
      username: encrypted(username),
      password: encrypted(password)
    }
  );
  return request;
}

export function fetchIdamanEdtpToken(accessToken) {
  const url = `${ROOT_URL}api/resauth/`;
  return axios.post(url, {}, cekAuthIdaman(accessToken));
}

export function fetchEmailExistx(username) {
  let url = `${ROOT_URL}api/profile/?search=${username}`;

  const request = axios.get(url, cekAuth());
  return request;
}

export function authVerify() {
  const url = `${ROOT_URL}api/login/`;
  const request = axios.post(
    url,
    { token: localStorage.getItem("token") },
    cekAuth()
  );

  return request;
}

export function patchAddUserx(username, email, password, company) {
  console.log(company);
  const url = `${ROOT_URL}api/profile/`;
  const request = axios.post(
    url,
    {
      name: username,
      email: email,
      password: password,
      brithday: "1989-01-01",
      gender: "male",
      login_type: "web",
      picture_background_url: "",
      picture_url: "",
      social_id: "",
      description: "-",
      job: "-",
      company_code: company,
      userlevel: 3,
      otp: 0,
      oauth: "-"
    },
    cekAuth()
  );
  return request;
}

export function patchAddUser__(username, email, password, company) {
  console.log(company);
  const url = `${ROOT_URL}api/profile/`;
  const request = axios.post(
    url,
    {
      name: encrypted(username),
      email: encrypted(email),
      password: encrypted(password),
      brithday: encrypted("1989-01-01"),
      gender: encrypted("male"),
      login_type: encrypted("web"),
      picture_background_url: encrypted("-"),
      picture_url: encrypted("-"),
      social_id: encrypted("-"),
      description: encrypted("-"),
      job: encrypted("-"),
      company_code: encrypted(company),
      userlevel: encrypted(3),
      otp: encrypted(0),
      oauth: encrypted("-")
    },
    cekAuth()
  );
  return request;
}

export function patchAddUser(username, email, password, company) {
  console.log(company);
  const url = `${ROOT_URL}api/profile/`;
  const request = axios.post(
    url,
    {
      name: username,
      email: email,
      password: encrypted(password),
      brithday: "1989-01-01",
      gender: "male",
      login_type: encrypted("web"),
      picture_background_url: encrypted("-"),
      picture_url: encrypted("-"),
      social_id: encrypted("-"),
      description: encrypted("-"),
      job: encrypted("-"),
      company_code: encrypted(company),
      userlevel: 5,
      otp: 0,
      oauth: encrypted("-")
    },
    cekAuth()
  );
  return request;
}

export function patchAddUseroauth(
  username,
  email,
  password,
  company,
  oauth,
  userlevel
) {
  console.log(company);
  const url = `${ROOT_URL}api/profile/`;
  const request = axios.post(
    url,
    {
      name: username,
      email: email,
      password: encrypted(password),
      brithday: "1989-01-01",
      gender: "male",
      login_type: encrypted("web"),
      picture_background_url: encrypted("-"),
      picture_url: encrypted("-"),
      social_id: encrypted("-"),
      description: encrypted("-"),
      job: encrypted("-"),
      company_code: encrypted(company),
      userlevel: userlevel,
      otp: 0,
      oauth: encrypted(oauth)
    },
    cekAuth()
  );
  return request;
}

export function fetchTokenIdaman(tokenIdaman) {
  const url = `${ROOT_URLIDAMAN}connect/userinfo`;

  const request = axios.post(
    url,
    {
      token: tokenIdaman
    },
    cekAuthIdaman(tokenIdaman)
  );
  return request;
}

export function fetchUserDetail(tokenIdaman, email) {
  const url = `${ROOT_URLINFOINDAMAN}v1/users/${email}`;

  const request = axios.get(url, cekAuthIdaman(tokenIdaman));
  return request;
}

export function fetchUserBelitRole(tokenIdaman, userid) {
  const url = `${ROOT_URLINFOINDAMAN}v1/Roles/${userid}`;

  const request = axios.get(url, cekAuthIdaman(tokenIdaman));
  return request;
}
